import React from 'react'

import { BaseIconProps, IconSizes, IconColors } from '../base'

const Add: React.FC<BaseIconProps> = React.forwardRef(
  ({ className, size = 'md', color = 'default' }, ref) => (
    <svg
      ref={ref}
      className={className}
      width={IconSizes[size]}
      height={IconSizes[size]}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 1V25"
        stroke={IconColors[color]}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25 13H1"
        stroke={IconColors[color]}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
)

export default Add
